import React from 'react'
import {useAppSelector} from 'store'
import {getSecretWord} from 'store/secretword/selectors'
import {SecretWord} from 'store/secretword/entities'
import {SecretLetterWrapper} from '../SecretLetterWrapper/SecretLetterWrapper'
import styles from './word.scss'

export const Word = () => {
  const secretWord: SecretWord = useAppSelector(getSecretWord)
  const secretWordKeys = Object.keys(secretWord)

  return (
    <div className={styles.wrapWord}>    
      {secretWordKeys.map(key => {
        const symbol = secretWord[Number(key)].symbol
        return (
          <SecretLetterWrapper
            key={`${key}-${symbol}`}
            symbol={symbol}
            isOpen={secretWord[Number(key)].isOpen}
          />
        )
      })}
    </div>
  )
}
